
export default {
  data() {
    return {
      isCalendlyActive: false,
      isDesktop: false,
      argument: {
        titleArgument: `Présentez votre entreprise sous son <span class="font-clash font-bold text-purple-brand">meilleur jour</span>`,
        surtitle: "Facilitez la gestion de vos réseaux sociaux",
        webArguments: [
          {
            title: "Design",
            text: "Confiez la création de vos publications aux experts ALEO et mettez en avant vos expertises.",
            img: require("~/assets/img/picto-paint.svg"),
            alt: "Retour sur investissement",
          },
          {
            title: "Régularité",
            text: "Avec 2 à 4 posts publiés chaque mois, profitez de tous les avantages d’une communication de qualité.",
            img: require("~/assets/img/picto-refresh.svg"),
            alt: "Retour sur investissement",
          },
          {
            title: "Image de marque",
            text: "Soyez présents sur les réseaux sociaux et rassurez vos clients avec une image professionnelle",
            img: require("~/assets/img/picto-stars.svg"),
            alt: "Retour sur investissement",
          },
        ],
      },
      arguments2: [
        {
          img: "argument-rs1.png",
          title: "Libérez votre temps",
          text: "On s'occupe de vos réseaux pendant que vous vous concentrez sur votre activité.",
          alt: "Savoir-faire sur les réseaux",
        },
        {
          img: "argument-cm-2.png",
          title: "Améliorez votre capital confiance",
          text: "Rassurez vos clients, avec un profil Facebook et Instagram actif professionnel et des  publications régulières de qualité.",
          alt: "Assurance et fidélisation",
        },
        {
          img: "argument-rs3.png",
          title: "Développez votre bouche à oreille",
          text: "Profitez du pouvoir d'une communication régulière pour améliorer votre notoriété et votre visibilité.",
          alt: "Gagner des abonnés",
        },
      ],
      reviewCollab: {
        author: "Maeva - Experte en gestion des réseaux sociaux",
        text: "Je crée des visuels attractifs sur les réseaux sociaux.",
        img: "Maeva.png",
        alt: "Experte Gestion Réseaux Sociaux ",
      },

      itemsList: [
        {
          title: "Un compte Facebook et Instagram actif et professionnel",
          text: "Nos équipes s’occupent pour vous de la création et de l’optimisation de votre page Facebook et Instagram.",
        },
        {
          title: "Une ligne éditoriale adaptée à votre activité",
          text: "Nous choisissons parmi de nombreuses thématiques qui ont fait leurs preuves celles qui seront le mieux adaptées à votre entreprise.",
        },
        {
          title: "Un calendrier de publication personnalisé",
          text: "Profitez de notre expérience sur plus de 15000 clients accompagnés pour construire des réseaux sociaux élégants et professionnels.",
        },
        {
          title: "2 à 4 publications par mois",
          text: "Grâce à nos experts, bénéficiez d’une communication régulière et de qualité pour développer votre notoriété !",
        },
      ],
      price: {
        price: 149,
        text: "La meilleure solution pour développer sa communauté !",
        engagement: "6 mois d'engagement",
      },

      timeline: {
        surtitle: "La gestion des réseaux sociaux chez aleo",
        title: `Comment ça <span class="text-primary-500 font-clash font-bold">marche</span>&nbsp;?`,
        steps: [
          {
            img: "seo-step-1.png",
            title: "Étude de votre activité",
            text: "Analyse de vos cibles, de votre zone géographique et de votre entreprise.",
            alt: "Ciblage Facebook Ads",
          },
          {
            img: "seo-step-2.png",
            title: "Création et optimisation de vos pages",
            text: "Pour chaque réseau social, nous concevons une bannière adaptée et optimisons votre présentation d’entreprise.",
            alt: "Partager votre page Facebook",
          },
          {
            img: "cm-step-2.png",
            title: "Conception de votre ligne éditoriale",
            text: "Pour animer vos réseaux sociaux et créer du contenu qui parle à vos prospects, nous élaborons une stratégie éditoriale personnalisée à votre entreprise.",
            alt: "Création planning de publication Facebook",
          },
          {
            img: "web-step-5.png",
            title: "Élaboration de votre planning de publication",
            text: "Pour développer vos réseaux sociaux dans les meilleures conditions, nos experts en community management créent un calendrier de publication adapté à votre stratégie sociale.",
            alt: "Création de publication et visuels",
          },
          {
            img: "web-step-2.png",
            title: "Création et publication de vos visuels",
            text: "Notre équipe s’occupe pour vous du design et de la rédaction de vos posts et de leur publication sur les réseaux sociaux.",
            alt: "Étude et rapport Google Ads",
          },
        ],
      },

      reviews: [
        {
          text: "Une belle communication avec beaucoup de professionnalisme.",
          author: "Met'Propre Nettoyage",
        },
        {
          text: "L'équipe ALEO a su parfaitement répondre à mes attentes !",
          author: "Entreprise CCZ",
        },
        {
          text: "Je suis très satisfait de ma collaboration avec cette agence : les visuels sont d'une grande qualité et la graphiste en charge de mon dossier est à l'écoute et réactive.",
          author: "AUTO-ÉCOLE NOTRE DAME",
        },
        {
          text: "Equipe sympathique. La créativité sur les publications est top ! J'apprécie le fait qu'on nous demande si on a du contenu à mettre en avant, ça permet d'être au plus proche de notre métier. Je suis satisfaite.",
          author: "LAURENCE FERRY",
        },
      ],

      faq: [
        {
          question:
            "Pourquoi confier la gestion de mes réseaux sociaux à ALEO ?",
          answer: `Confier la <strong>gestion de vos réseaux sociaux</strong> à ALEO vous permettra de bénéficier du pouvoir d’une communication régulière et de qualité sans avoir à y penser.
Nos <strong>community managers</strong> s’occuperont pour vous du <strong>contenu</strong>, du <strong>design</strong> et de la <strong>rédaction</strong> de vos posts pour que vous puissiez observer votre nombre d’abonnés évoluer en toute sérénité.`,
          isCollapsed: false,
        },
        {
          question:
            "Est-ce que mes publications seront sur Facebook et Instagram ?",
          answer: `Pour assurer la <strong>gestion de vos réseaux sociaux</strong> dans leur intégralité et vous permettre les meilleurs résultats, vos publications seront à la fois publiées sur <strong>Facebook</strong> et <strong>Instagram</strong>.`,
          isCollapsed: false,
        },
        {
          question:
            "Je n’ai pas de compte Facebook ou Instagram, est-ce qu’ALEO peut créer mon compte ?",
          answer: `Pour vous permettre d’avoir une <strong>stratégie social media</strong> optimale, les équipes ALEO s’occupent de la création de votre compte Facebook et de votre compte Instagram.
Si vous avez déjà un compte sur ces deux plateformes, les équipes ALEO optimiseront vos pages en créant une nouvelle bannière et en rédigeant la présentation de votre entreprise.`,
          isCollapsed: false,
        },
        {
          question: "Combien de posts seront publiés par mois ?",
          answer: `En fonction de vos besoins et de l’offre que vous choisirez pour optimiser votre <strong>stratégie social media</strong>, les équipes ALEO publieront 2 ou 4 posts par mois sur vos comptes <strong>Facebook et Instagram</strong>.`,
          isCollapsed: false,
        },
        {
          question:
            "Est-ce que ALEO s’occupe de la modération de mes commentaires ?",
          answer: `Pour vous permettre de garder le contrôle sur la manière dont vous souhaitez répondre à votre audience, les équipes ALEO n’effectuent pas la modération de vos commentaires.`,
          isCollapsed: false,
        },
        {
          question:
            "Est-ce que les thématiques de mes posts seront définies à l’avance ?",
          answer: `<p>Oui. Pour vous permettre une <strong>gestion fluide de vos réseaux sociaux</strong>, les équipes ALEO créeront un calendrier de publications avec des thématiques efficaces ayant déjà eu de bons résultats dans d’autres <strong>stratégies social media</strong>.</p>

<p>Par exemple : Présentation de vos produits, mise en avant de vos avis clients, citations, Astuces, Offres d’emploi, Présentation d’équipe, etc.</p>
`,
          isCollapsed: false,
        },
      ],
    };
  },
  head() {
    return {
      title: "Agence gestion des réseaux sociaux | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Rassurez vos clients avec du contenu de qualité publié régulièrement sur Facebook et Instagram.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence gestion des réseaux sociaux | Agence ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Rassurez vos clients avec du contenu de qualité publié régulièrement sur Facebook et Instagram.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-rs.jpg"),
        // },
      ],
    };
  },

  mounted() {
    this.watchMedia();
  },

  methods: {
    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);
    },

    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },
  },
};
